<script>
import _ from 'lodash'

import posthog from 'posthog-js'
import TwInputText from '~/components/TwInputText.vue'

const Sumary = () => import('~/components/Sumary.vue')
const Payment = () => import('~/components/Payment.vue')
const CartItems = () => import('~/components/CartItems.vue')
const Orderbump = () => import('~/components/Orderbump.vue')

import Swal from 'sweetalert2'
import { clearString, convertCurrency } from '~/assets/js/methods'
import { getAddressData } from '~/assets/js/requests'

import VueModal from '@kouts/vue-modal'
import '@kouts/vue-modal/dist/vue-modal.css'

export default {
    name: 'FormCheckout',
    components: {
        TwInputText,
        Sumary,
        Payment,
        CartItems,
        Modal: VueModal,
        Orderbump,
    },
    setup() {
        return {
            convertCurrency,
        }
    },
    computed: {
        checkToSaveLead() {
            return this.checkLeadValid !== false &&
                this.checkAddressValid !== false
                ? true
                : false
        },
        checkFirstStepValid() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true
                ? false
                : true
        },
        checkLeadValid() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true ||
                this.validation['zip_code'] !== true ||
                this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        checkAddressValid() {
            return this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        checkPaymentValid() {
            if (this.paymentMethodSelected === 1) {
                return this.validation['card_number'] !== true ||
                    this.validation['card_holdername'] !== true ||
                    this.validation['card_expiration'] !== true ||
                    this.validation['card_cvv'] !== true ||
                    this.validation['cpf'] !== true
                    ? false
                    : true
            } else {
                return this.validation['cpf'] !== true ? false : true
            }
        },
        paymentMethodSelected() {
            return this.payment_method
        },
    },
    watch: {
        // COMO NÃO ESTÃOS SENDO UTILIZADOS, FOI COMENTADO
        // checkLeadValid: {
        //     handler(e) {
        //         if (e !== false) {

        //         }
        //     }
        // },
        // checkAddressValid: {
        //     handler(e) {
        //         if (e !== false) {

        //         }
        //     }
        // },
        checkPaymentValid: {
            handler(e) {
                if (e !== false) {
                    this.$nextTick(() => {
                        this.scrollToElement('frame_orderbumps')
                    })
                }
            },
        },
        checkFirstStepValid: {
            handler(e) {
                if (e !== false) {
                    this.$nextTick(() => {
                        this.$store.commit('setEventsState', { Lead: true })
                        this.$store.commit('setFirstStepValid', true)

                        if (process.env.NODE_ENV === 'production') {
                            try {
                                posthog.people.set({
                                    name: this.lead.name,
                                    email: this.lead.email,
                                    phone: this.lead.phone_number,
                                })
                            } catch (error) {
                                fetch(
                                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                                    {
                                        method: 'POST',
                                        mode: 'cors',
                                        headers: {
                                            Accept: 'application/json',
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            title: `FormCheckout Error`,
                                            message: `${error}`,
                                        }),
                                    }
                                )
                            }
                        }

                        // DEPOIS QUE A PRIMEIRA ETAPA FOR VÁLIDA, AGUARDA 2 SEGUNDOS PARA SALVAR O LEAD
                        // ESSES DOIS SEGUNDOS É O TEMPO DE SER INPUTADO OUTRO CARACTER, NO CASO DE VALIDAÇÃO DE TELEFONE
                        setTimeout(() => {
                            this.saveCustomerPost()
                        }, 2000)
                    })
                } else {
                    this.$store.commit('setFirstStepValid', false)
                }
            },
        },
        'validation.email': {
            handler(e) {
                if (e === true) {
                    this.checkEmailValid = true
                }
            },
        },
        'lead.zip_code': {
            handler(e) {
                if (
                    typeof e !== 'undefined' &&
                    e !== false &&
                    e !== '00000000'
                ) {
                    let zipCode = clearString(e)

                    if (zipCode.length === 8) {
                        if (this.lead.street_name == '') {

                            try {
                                Swal.fire({
                                    title: 'Buscando endereço',
                                    html: 'Aguarde',
                                    allowOutsideClick: !1,
                                    returnFocus: false,
                                    didOpen: () => {
                                        Swal.showLoading()
                                    },
                                })

                                getAddressData(zipCode)
                                    .then((response) => {
                                        if (
                                            typeof response.erro !==
                                                'undefined' &&
                                            response.erro === true
                                        ) {
                                            this.$nextTick(() => {
                                                this.elementFocus('street_name')
                                            })
                                        } else {
                                            this.lead['street_name'] =
                                                response.logradouro ?? ''
                                            this.lead['neighborhood'] =
                                                response.bairro ?? ''
                                            this.lead['city'] =
                                                response.localidade ?? ''
                                            this.lead['state'] =
                                                response.uf ?? ''

                                            this.$nextTick(() => {
                                                this.elementFocus('number')
                                            })
                                        }

                                        Swal.close()
                                    })
                                    .catch((e) => {
                                        console.error(
                                            'Erro ao buscar endereço:',
                                            e
                                        )
                                        this.$nextTick(() => {
                                            this.elementFocus('street_name')
                                        })

                                        Swal.close()
                                    })
                            } catch (error) {
                                fetch(
                                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                                    {
                                        method: 'POST',
                                        mode: 'cors',
                                        headers: {
                                            Accept: 'application/json',
                                            'Content-Type': 'application/json',
                                        },
                                        body: JSON.stringify({
                                            title: `BuscarEndereço Error`,
                                            message: `${error}`,
                                        }),
                                    }
                                )
                            }
                        } else {
                            this.checkValid()
                        }
                    }
                }
            },
        },
        paymentMethodSelected: {
            handler(e) {
                // reseta a validação do cartão, quando troca para PIX

                this.$store.commit('setPaymentMethodSelected', e)

                if (e === 1) {
                    // this.payment.card_number = "";
                    this.validation['card_number'] = null
                    this.validation['card_holdername'] = null
                    this.validation['card_expiration'] = null
                    this.validation['card_cvv'] = null

                    if (this.checkFirstStepValid !== false) {
                        this.$nextTick(() => {
                            this.elementFocus('card_number')
                        })
                    }

                    this.lead['zip_code'] =
                        this.lead['zip_code'] !== '00000000'
                            ? this.lead['zip_code']
                            : ''
                    this.lead['street_name'] =
                        this.lead['street_name'] !== 'null'
                            ? this.lead['street_name']
                            : ''
                    this.lead['number'] =
                        this.lead['number'] !== 'null'
                            ? this.lead['number']
                            : ''
                    this.lead['neighborhood'] =
                        this.lead['neighborhood'] !== 'null'
                            ? this.lead['neighborhood']
                            : ''
                    this.lead['city'] =
                        this.lead['city'] !== 'null' ? this.lead['city'] : ''
                    this.lead['state'] =
                        this.lead['state'] !== 'null' ? this.lead['state'] : ''
                } else if (e === 3 || e === 2) {
                    // QUAND O MÉTODO DE PAGAMENTO FOR PIX OU BOLETO REMOVE A VALIDAÇÃO DO CARTÃO
                    delete this.validation.card_number
                    delete this.validation.card_holdername
                    delete this.validation.card_expiration
                    delete this.validation.card_cvv

                    this.lead['zip_code'] =
                        this.lead['zip_code'] !== ''
                            ? this.lead['zip_code']
                            : '00000000'
                    this.lead['street_name'] =
                        this.lead['street_name'] !== ''
                            ? this.lead['street_name']
                            : 'null'
                    this.lead['number'] =
                        this.lead['number'] !== ''
                            ? this.lead['number']
                            : 'null'
                    this.lead['neighborhood'] =
                        this.lead['neighborhood'] !== ''
                            ? this.lead['neighborhood']
                            : 'null'
                    this.lead['city'] =
                        this.lead['city'] !== '' ? this.lead['city'] : 'null'
                    this.lead['state'] =
                        this.lead['state'] !== '' ? this.lead['state'] : 'null'

                    this.validation['zip_code'] = true
                    this.validation['street_name'] = true
                    this.validation['number'] = true
                    this.validation['neighborhood'] = true
                    this.validation['city'] = true
                    this.validation['state'] = true

                    this.$nextTick(() => {
                        this.$store.commit(
                            'setCustomer',
                            JSON.parse(JSON.stringify(this.lead))
                        )
                    })

                    if (
                        this.checkFirstStepValid !== false &&
                        this.validation['cpf'] !== true
                    ) {
                        this.$nextTick(() => {
                            this.elementFocus('cpf')
                        })
                    }
                }
            },
            immediate: true,
        },
        submitting: {
            handler(e) {
                console.warn('FAZENDO O SUBMIT', e)
                if (e !== false) {
                    // fetch(
                    //     `https://api.unicopag.com.br/api/api/notifications/errors`,
                    //     {
                    //         method: 'POST',
                    //         mode: 'cors',
                    //         headers: {
                    //             Accept: 'application/json',
                    //             'Content-Type': 'application/json',
                    //         },
                    //         body: JSON.stringify({
                    //             title: `Tentativa de compra`,
                    //             message: `Uma venda precisa chegar a seguir... Customer: ${this.lead.email}`,
                    //             level: 'notice'
                    //         }),
                    //     }
                    // )
                }
            },
        },
    },
    methods: {
        checkPaymentValidMethod() {
            if (this.paymentMethodSelectedMethod() == 1) {
                return this.validation['card_number'] !== true ||
                    this.validation['card_holdername'] !== true ||
                    this.validation['card_expiration'] !== true ||
                    this.validation['card_cvv'] !== true ||
                    this.validation['cpf'] !== true
                    ? false
                    : true
            } else {
                return this.validation['cpf'] !== true ? false : true
            }
        },
        checkPaymentValidMethod() {
            if (this.paymentMethodSelectedMethod() == 1) {
                return this.validation['card_number'] !== true ||
                    this.validation['card_holdername'] !== true ||
                    this.validation['card_expiration'] !== true ||
                    this.validation['card_cvv'] !== true ||
                    this.validation['cpf'] !== true
                    ? false
                    : true
            } else {
                return this.validation['cpf'] !== true ? false : true
            }
        },
        checkFirstStepValidMethod() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true
                ? false
                : true
        },
        checkLeadValidMethod() {
            return this.validation['name'] !== true ||
                this.validation['email'] !== true ||
                this.validation['phone_number'] !== true ||
                this.validation['zip_code'] !== true ||
                this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        checkAddressValidMethod() {
            return this.validation['street_name'] !== true ||
                this.validation['number'] !== true ||
                this.validation['neighborhood'] !== true ||
                this.validation['city'] !== true ||
                this.validation['state'] !== true
                ? false
                : true
        },
        paymentMethodSelectedMethod() {
            return this.payment_method
        },
        saveCustomerPost() {
            let this_el = this
            if (
                typeof this.$store.getters['getCustomer']['email'] !==
                    'undefined' &&
                this.$store.getters['getCustomer']['email'] !== ''
            ) {
                this.$axios
                    .post(
                        '' +
                            this.$config.URL_API +
                            '/checkout/customers/' +
                            this.$route.params.page,
                        {
                            customer: JSON.parse(
                                JSON.stringify(
                                    this.$store.getters['getCustomer']
                                )
                            ),
                            cart: JSON.parse(
                                JSON.stringify(this.$store.getters['getCart'])
                            ),
                            tracking: JSON.parse(
                                JSON.stringify(
                                    this.$store.getters['getTracking']
                                )
                            ),
                            url: location.href,
                        },
                        { progress: false }
                    )
                    .then(function (result) {
                        console.warn(result)
                        this_el.lead['hash'] = result.data['hash']

                        this_el.$nextTick(() => {
                            this_el.$store.commit(
                                'setCustomer',
                                JSON.parse(JSON.stringify(this_el.lead))
                            )
                            posthog.capture('saveLead', result)
                        })
                    })
                    .catch(function (err) {
                        console.error('saveCustomerPostError:', err)
                        posthog.capture('saveCustomerPostError', err)
                        fetch(
                            `https://api.unicopag.com.br/api/api/notifications/errors`,
                            {
                                method: 'POST',
                                mode: 'cors',
                                headers: {
                                    Accept: 'application/json',
                                    'Content-Type': 'application/json',
                                },
                                body: JSON.stringify({
                                    title: `saveCustomerPost Error`,
                                    message: `${err}`,
                                }),
                            }
                        )
                    })

                // fetch('https://5cc1af.myshopify.com/admin/api/2023-04/customers.json', {
                //     method: 'POST',
                //     mode: 'cors',
                //     headers: {
                //         'X-Shopify-Access-Token': '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',
                //         'Content-Type': 'application/json',
                //         'Accept': 'application/json',
                //     },
                //     body: JSON.stringify({
                //         customer: {
                //             first_name: this.$store.getters['getCustomer'].name.split(' ')[0],
                //             last_name: this.$store.getters['getCustomer'].name.split(' ')[1] ?? "",
                //             email: this.$store.getters['getCustomer'].email,
                //             phone: '+55' + this.$store.getters['getCustomer'].phone_number
                //         }
                //     })
                // }).then((result) => {
                // })
            } else {
                console.warn(
                    'Email indefinido',
                    this.$store.getters['getCustomer']['email']
                )
            }
        },
        scrollToElement(element) {
            this.$nextTick(() => {
                try {
                    let element_html = document.getElementById(element)
                    if (
                        typeof element_html != 'undefined' &&
                        element_html != null
                    ) {
                        let absoluteElementTop = null
                        this.$nextTick(() => {
                            const rect = element_html.getBoundingClientRect()
                            absoluteElementTop = rect.top + window.pageYOffset
                            const middle =
                                absoluteElementTop - window.innerHeight / 2

                            window.scrollTo(0, middle)
                        })
                    }
                } catch (error) {
                    fetch(
                        `https://api.unicopag.com.br/api/api/notifications/errors`,
                        {
                            method: 'POST',
                            mode: 'cors',
                            headers: {
                                Accept: 'application/json',
                                'Content-Type': 'application/json',
                            },
                            body: JSON.stringify({
                                title: `scrollToElement Error`,
                                message: `${error}`,
                            }),
                        }
                    )
                }
            })
        },
        checkValid(force_submiting = true) {
            try {

                let submit_form = true

                let invalids = []
                let array = []
                let array_values = []

                array = Object.keys(this.validation)
                array_values = Object.values(this.validation)

                array_values.forEach((v, k) => {
                    if (v !== true && v === null) {
                        invalids.push(array[k])
                        submit_form = false
                    } else if (v === false) {
                        invalids.push(array[k])
                        submit_form = false
                    }
                })

                function removeItemAll(arr, value) {
                    var i = 0
                    while (i < arr.length) {
                        if (arr[i] === value) {
                            arr.splice(i, 1)
                        } else {
                            ++i
                        }
                    }
                    return arr
                }

                this.$nextTick(() => {
                    if (submit_form !== false) {
                        if (force_submiting !== false) {

                            if (
                                this.last_event !== 'isEnter' ||
                                this.isClickSubmitButton === true
                            ) {
                                this.submitting = true
                                // reseta o click no submit
                                this.isClickSubmitButton = false
                            }
                        }
                    } else {
                        if (
                            this.checkPaymentValidMethod() !== false &&
                            this.paymentMethodSelectedMethod() == 1 &&
                            this.checkFirstStepValidMethod() !== false
                        ) {
                            if (this.checkAddressValidMethod() === false) {
                                this.showModal = true
                                this.$nextTick(() => {
                                    this.elementFocus(invalids[0])
                                })
                            }
                        } else {
                            if (this.paymentMethodSelectedMethod() == 1) {
                                removeItemAll(invalids, 'zip_code')
                                removeItemAll(invalids, 'street_name')
                                removeItemAll(invalids, 'number')
                                removeItemAll(invalids, 'complement')
                                removeItemAll(invalids, 'neighborhood')
                                removeItemAll(invalids, 'city')
                                removeItemAll(invalids, 'state')
                            }

                            this.$nextTick(() => {
                                this.elementFocus(invalids[0])
                            })
                        }
                    }
                })

                console.warn(invalids)
            } catch (error) {
                fetch(
                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                    {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `checkValid Error`,
                            message: `${error}`,
                        }),
                    }
                )
            }
        },
        updateFieldsForm(e) {
            try {
                this.validation[e['field']] = e['valid']
                this[e['var']][e['field']] = e['value']

                this.setStoreInputs(JSON.parse(JSON.stringify(e)))

                this.$nextTick(() => {
                    // Envia LEAD para a Store

                    if (e['event'] !== null) {
                        if (e['event'] === 'isChange' && e['value'] !== '') {

                            // SÓ SALVA O LEAD NO BACKEND SE TIVER AO MENOS FIRSTSTEP VALID E TAMBÉM O ZIP CODE PREENCHIDO

                            if (
                                this.checkFirstStepValid !== false &&
                                [e['var']] == 'lead'
                            ) {
                                this.saveLeadAfterValid()
                            }
                        } else {
                            if (e['event'] === 'isEnter') {
                                this.last_event = e['event']
                                this.checkValid()
                            }

                            // if ((e['event'] === 'isEnter' || e['event'] === 'isFocusOut') && e['value'] !== '') {
                            //     this.$nextTick(() => {
                            //         this.saveLeadAfterValid();
                            //     })
                            // }
                        }
                    }
                })
            } catch (error) {
                console.error(error)
                fetch(
                    `https://api.unicopag.com.br/api/api/notifications/errors`,
                    {
                        method: 'POST',
                        mode: 'cors',
                        headers: {
                            Accept: 'application/json',
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            title: `updateFieldsForm Error`,
                            message: `${error}`,
                        }),
                    }
                )
            }
        },
        setStoreInputs(e) {


            this.first_load = true

            if ([e['var']] == 'lead') {
                this.$store.commit(
                    'setCustomer',
                    JSON.parse(JSON.stringify(this.lead))
                )
            }

            if ([e['var']] == 'payment') {
                this.$store.commit(
                    'setPaymentData',
                    JSON.parse(JSON.stringify(this.payment))
                )
            }
        },
        saveLeadAfterValid: _.debounce(function (e) {
            this.saveCustomerPost()
        }, 500),
        callbackSubmit(e) {

            if (e === false) {
                this.submitting = false
            }
        },
        elementFocus(el) {
            let element_html = document.getElementById(el)

            if (typeof element_html !== 'undefined' && element_html !== null) {
                try {
                    element_html.focus()
                    this.$nextTick(() => {
                        this.forceValidation[el] = true
                    })
                } catch {
                    this.scrollToElement(el)
                    this.forceValidation[el] = true
                }
            } else {

            }
        },
        modalFechado() {
            if (
                this.checkLeadValid !== false &&
                this.checkAddressValid !== false &&
                this.checkPaymentValid !== false
            ) {

                // CUIDADO AO DESCOMENTAR A FUNÇÃO ABAIXO. ELA ESTA IRÁ ENVIAR MAIS DE UM REQUEST AO CLICAR EM CONCLUIR A COMPRA NO MODAL DO ENDEREÇO
                // this.checkValid();
            } else {

            }
        },
    },
    data() {
        return {
            lead: {
                name: '',
                hash: '',
                email: '',
                phone_number: '',
                zip_code: '',
                street_name: '',
                number: '',
                complement: '',
                neighborhood: '',
                city: '',
                state: '',
                cpf: '',
            },
            payment: {
                card_number: '',
                card_holdername: '',
                card_expiration: '',
                card_cvv: '',
            },
            shipping: '',
            validation: {
                name: null,
                email: null,
                phone_number: null,
                zip_code: null,
                street_name: null,
                number: null,
                neighborhood: null,
                city: null,
                state: null,
                card_number: null,
                card_holdername: null,
                card_expiration: null,
                card_cvv: null,
                cpf: null,
            },
            forceValidation: {
                name: false,
                email: false,
                phone_number: false,
                zip_code: false,
                street_name: false,
                number: false,
                neighborhood: false,
                city: false,
                state: false,
                card_number: false,
                card_holdername: false,
                card_expiration: false,
                card_cvv: false,
                cpf: false,
            },
            payment_method: '',
            payment_methods: '',
            submitting: false,
            first_load: false,
            showModal: false,
            custom_form_checkout: [],
            last_event: '',
            isClickSubmitButton: false,
            checkEmailValid: false,
        }
    },
    created() {
        if (localStorage.getItem('customer')) {
            this.lead = JSON.parse(localStorage.getItem('customer'))
        }

        if (localStorage.getItem('paymentData')) {
            this.payment = JSON.parse(localStorage.getItem('paymentData'))
            this.payment.card_cvv = ''
        }
    },
    beforeMount() {
        if (process.client) {
            this.payment_methods = this.$store.getters['getPaymentMethods']
        }
    },
    mounted() {
        this.payment_method = 1
        // fazendo o deploy 1

    },
}
</script>
<template>
    <div>
        <form
            @submit.prevent.stop="checkValid"
            ref="form"
            novalidate
            class="m-0 p-0"
            autocomplete="on"
        >
            <div
                class="overflow-hidden rounded-lg bg-white my-2 px-3 py-3 shadow-md border-t-4 border-gray-100"
            >
                <div class="mb-3 pb-2 border-b leading-none">
                    <span
                        class="p-1 w-6 h-6 rounded-full bg-blue-700 text-white inline-block text-center"
                        >1</span
                    >
                    <h3
                        class="text-lg font-medium leading-none text-gray-900 inline-block"
                    >
                        Identifique-se
                    </h3>
                    <p class="mt-2 text-xs">
                        Utilizaremos seu e-mail para: Identificar seu perfil,
                        histórico de compra, notificação de pedidos e carrinho
                        de compras.
                    </p>
                </div>
                <div class="flex flex-wrap">
                    <TwInputText
                        @updateFieldsForm="updateFieldsForm"
                        class_names="w-full md:w-1/2"
                        ref="name"
                        :forceValidation="forceValidation.name"
                        type="text"
                        name="name"
                        :value="lead.name"
                        var="lead"
                        autocomplete="name"
                        errors="Informe seu nome"
                        label="Nome completo"
                        :rules="{ required: true, minlenght: 2 }"
                        placeholder="Seu nome"
                    />

                    <TwInputText
                        @updateFieldsForm="updateFieldsForm"
                        class_names="w-full md:w-1/2"
                        ref="email"
                        :forceValidation="forceValidation.email"
                        type="email"
                        name="email"
                        :value="lead.email"
                        var="lead"
                        autocomplete="email"
                        errors="Informe um e-mail"
                        label="E-mail"
                        :rules="{ required: true, email: true }"
                        placeholder="Ex: exemplo@gmail.com"
                    />

                    <TwInputText
                        @updateFieldsForm="updateFieldsForm"
                        class_names="w-full md:w-1/2"
                        ref="phone_number"
                        :forceValidation="forceValidation.phone_number"
                        type="tel"
                        name="phone_number"
                        :value="lead.phone_number"
                        var="lead"
                        autocomplete="tel-national"
                        :maxlenght="20"
                        errors="Informe o número do telefone celular"
                        label="Celular com DDD"
                        :rules="{ required: true, phone_number: true }"
                        :masksD="[
                            '(##) ####-####',
                            '(##) #####-####',
                            '(##) #####-####',
                        ]"
                        placeholder="(00) 9 0000-0000"
                    />
                </div>

                <button
                    v-if="!checkFirstStepValid"
                    @click="
                        () => {
                            if (validation.email) {
                                checkEmailValid = true
                            }
                        }
                    "
                    class="mt-3 border-b-4 border-green-700 w-full items-center py-3 disabled:bg-opacity-50 font-semibold leading-6 text-xl text-center justify-center shadow rounded-md text-white bg-green-600"
                >
                    CONTINUAR
                </button>
            </div>

            <div
                v-if="checkFirstStepValid"
                class="overflow-hidden rounded-lg bg-white my-2 px-3 py-3 shadow-md border-t-4 border-gray-100"
            >
                <div class="mb-3 pb-2 border-b leading-none">
                    <span
                        class="p-1 w-6 h-6 rounded-full bg-blue-700 text-white inline-block text-center"
                        >2</span
                    >
                    <h3
                        class="text-lg font-medium leading-none text-gray-900 inline-block"
                    >
                        Endereço
                    </h3>
                    <p class="mt-2 text-xs">Endereço de Entrega</p>
                </div>

                <div class="flex flex-wrap">
                    <TwInputText
                        @updateFieldsForm="updateFieldsForm"
                        class_names="w-full md:w-1/2"
                        :masksD="['########', '#####-###']"
                        ref="zip_code"
                        :forceValidation="forceValidation.zip_code"
                        type="tel"
                        name="zip_code"
                        :value="lead.zip_code"
                        var="lead"
                        errors="Informe o CEP"
                        label="CEP - Endereço"
                        :rules="{ required: true, zip_code: true }"
                        autocomplete="postal-code"
                        placeholder="00000-000"
                    />

                    <div
                        v-if="validation.zip_code"
                        class="w-full flex flex-wrap"
                    >
                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="street_name"
                            :forceValidation="forceValidation.street_name"
                            type="text"
                            name="street_name"
                            :value="lead.street_name"
                            var="lead"
                            errors="Informe o nome da Rua"
                            label="Nome da Rua"
                            :rules="{ required: true, minlenght: 2 }"
                            autocomplete="shipping address-line1"
                            placeholder="Rua, Estrada, etc.."
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="number"
                            :forceValidation="forceValidation.number"
                            type="text"
                            name="number"
                            :value="lead.number"
                            var="lead"
                            errors="Informe o número"
                            label="Número"
                            :rules="{ required: true }"
                            autocomplete="shipping address-line2"
                            placeholder="Número da Casa, APTO, etc.."
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="complement"
                            :forceValidation="forceValidation.complement"
                            type="text"
                            name="complement"
                            :value="lead.complement"
                            var="lead"
                            errors=""
                            label="Complemento"
                            rules=""
                            autocomplete="shipping address-level4"
                            placeholder="Complemento do Endereço"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="neighborhood"
                            :forceValidation="forceValidation.neighborhood"
                            type="text"
                            name="neighborhood"
                            :value="lead.neighborhood"
                            var="lead"
                            errors="Bairro"
                            label="Bairro"
                            :rules="{ required: true }"
                            autocomplete="shipping address-level3"
                            placeholder="Bairro"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="city"
                            :forceValidation="forceValidation.city"
                            type="text"
                            name="city"
                            :value="lead.city"
                            var="lead"
                            errors="Cidade"
                            label="Cidade"
                            :rules="{ required: true }"
                            autocomplete="shipping address-level2"
                            placeholder="Cidade"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            ref="state"
                            :forceValidation="forceValidation.state"
                            type="select"
                            name="state"
                            :value="lead.state"
                            var="lead"
                            errors="Estado"
                            label="Estado"
                            :rules="{ required: true }"
                            autocomplete="state"
                            placeholder="Estado"
                            :select_values="[
                                'AC',
                                'AL',
                                'AP',
                                'AM',
                                'BA',
                                'CE',
                                'DF',
                                'ES',
                                'GO',
                                'MA',
                                'MT',
                                'MS',
                                'MG',
                                'PA',
                                'PB',
                                'PR',
                                'PE',
                                'PI',
                                'RJ',
                                'RN',
                                'RS',
                                'RO',
                                'RR',
                                'SC',
                                'SP',
                                'SE',
                                'TO',
                            ]"
                        />
                    </div>
                </div>
            </div>

            <!-- <div class="mb-5 overflow-hidden rounded-lg bg-white px-3 py-4 shadow-md border-t-4" v-if="first_step && operationType !== 4">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            	                        <div class="mb-3 pb-2 border-b leading-none">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            	                            <span class="p-1 w-6 h-6 rounded-full bg-blue-700 text-white inline-block text-center">2</span> <h3 class="text-lg font-medium leading-none text-gray-900 inline-block">Endereço</h3>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            	                        </div>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     		                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            	                    </div> -->

            <!-- v-if="checkFirstStepValid" -->
            <div
                v-if="checkAddressValid"
                class="overflow-hidden rounded-lg bg-white my-3 px-3 py-3 shadow-md border-t-4 border-gray-100"
            >
                <div class="">
                    <div class="mb-3 pb-2 border-b leading-none">
                        <span
                            class="p-1 w-6 h-6 rounded-full bg-blue-700 text-white inline-block text-center"
                            >3</span
                        >
                        <h3
                            class="text-lg font-medium leading-none text-gray-900 inline-block"
                        >
                            Pagamento
                        </h3>
                    </div>
                    <fieldset>
                        <legend class="sr-only">Métodos de Pagamento</legend>
                        <div class="relative -space-y-px rounded-md bg-white">
                            <!-- Checked: "z-10 border-indigo-200 bg-indigo-50", Not Checked: "border-gray-200" -->
                            <label
                                @click.prevent.stop="payment_method = 1"
                                :class="{
                                    'z-10 border-indigo-200 bg-indigo-50':
                                        payment_method === 1,
                                }"
                                class="border-gray-200 rounded-tl-md rounded-tr-md relative flex cursor-pointer flex-col border p-4 focus:outline-none md:pl-4 md:pr-6 overflow-hidden"
                            >
                                <span class="flex items-center text-sm">
                                    <input
                                        type="radio"
                                        name="payment_method"
                                        value="1"
                                        :checked="paymentMethodSelected === 1"
                                        :aria-checked="
                                            paymentMethodSelected === 1
                                        "
                                        class="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-600"
                                        aria-labelledby="payment_method-0-label"
                                        aria-describedby="payment_method-0-description-0"
                                    />
                                    <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                                    <span
                                        id="payment_method-0-label"
                                        class="ml-3 font-medium text-gray-900 flex items-center text-lg"
                                        :class="{
                                            'text-indigo-900':
                                                paymentMethodSelected === 1,
                                        }"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 576 512"
                                            class="w-6 h-6 inline-block text-md fill-blue-500"
                                        >
                                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                            <path
                                                d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >Cartão de Crédito</span
                                        >
                                    </span>
                                </span>
                            </label>

                            <label
                                v-if="payment_methods.includes('3')"
                                @click.prevent.stop="payment_method = 3"
                                :class="{
                                    'z-10 border-indigo-200 bg-indigo-50':
                                        paymentMethodSelected === 3,
                                    'rounded-bl-md rounded-br-md':
                                        !payment_methods.includes('2'),
                                }"
                                class="border-gray-200 relative flex cursor-pointer flex-col border p-4 focus:outline-none md:pl-4 md:pr-6 overflow-hidden"
                            >
                                <span class="flex items-center text-sm">
                                    <input
                                        type="radio"
                                        name="payment_method"
                                        value="3"
                                        :checked="paymentMethodSelected === 3"
                                        :selected="paymentMethodSelected === 3"
                                        :aria-checked="
                                            paymentMethodSelected === 3
                                        "
                                        class="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-600"
                                        aria-labelledby="payment_method-3-label"
                                        aria-describedby="payment_method-03-description-0"
                                    />
                                    <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                                    <span
                                        id="payment_method-3-label"
                                        class="ml-3 font-medium text-gray-900 flex items-center text-lg"
                                        :class="{
                                            'text-indigo-900':
                                                paymentMethodSelected === 3,
                                        }"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-6 h-6 fill-green-500"
                                        >
                                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                            <path
                                                d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >PIX</span
                                        >
                                    </span>
                                </span>
                            </label>

                            <label
                                v-if="payment_methods.includes('2')"
                                @click.prevent.stop="payment_method = 2"
                                :class="{
                                    'z-10 border-indigo-200 bg-indigo-50':
                                        paymentMethodSelected === 2,
                                }"
                                class="rounded-bl-md rounded-br-md relative flex cursor-pointer flex-col border p-4 focus:outline-none md:pl-4 md:pr-6 overflow-hidden"
                            >
                                <span class="flex items-center text-sm">
                                    <input
                                        type="radio"
                                        name="payment_method"
                                        value="2"
                                        :checked="paymentMethodSelected === 2"
                                        :aria-checked="
                                            paymentMethodSelected === 2
                                        "
                                        class="h-4 w-4 text-indigo-600 border-gray-300 focus:ring-indigo-600"
                                        aria-labelledby="payment_method-2-label"
                                        aria-describedby="payment_method-2-description-2"
                                    />
                                    <!-- Checked: "text-indigo-900", Not Checked: "text-gray-900" -->
                                    <span
                                        id="payment_method-2-label"
                                        class="ml-3 font-medium text-gray-900 flex items-center text-lg"
                                        :class="{
                                            'text-indigo-900':
                                                paymentMethodSelected === 2,
                                        }"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-6 h-6"
                                        >
                                            <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                            <path
                                                d="M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >Boleto Bancário</span
                                        >
                                    </span>
                                </span>
                            </label>
                        </div>
                    </fieldset>

                    <div v-if="false" class="grid grid-cols-1 gap-y-2 gap-x-2">
                        <label
                            v-if="payment_methods.includes('1')"
                            @click="payment_method = 1"
                            class="relative overflow-hidden flex cursor-pointer rounded-lg border bg-white p-2 shadow-sm focus:outline-none"
                            :class="{
                                'border-2 ring-indigo-600 border-indigo-600':
                                    payment_method === 1,
                            }"
                        >
                            <span class="flex">
                                <span class="flex">
                                    <span
                                        id="delivery-method-0-label"
                                        class="text-md font-medium text-gray-900 leading-none inline-flex items-center"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 576 512"
                                            class="w-6 h-6 inline-block text-md fill-blue-500"
                                        >
                                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                            <path
                                                d="M64 32C28.7 32 0 60.7 0 96v32H576V96c0-35.3-28.7-64-64-64H64zM576 224H0V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V224zM112 352h64c8.8 0 16 7.2 16 16s-7.2 16-16 16H112c-8.8 0-16-7.2-16-16s7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16H368c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >Cartão de Crédito</span
                                        >
                                    </span>
                                    <!-- <span id="delivery-method-0-description-0" class="mt-1 flex items-center text-sm text-gray-500">Aprovação Imediata</span> -->
                                    <!-- <span id="delivery-method-0-description-1" class="mt-2 text-sm font-medium text-gray-900">Até 12x R$ 25,00</span> -->
                                </span>
                            </span>
                            <svg
                                class="h-5 w-5 text-indigo-600 absolute top-0 right-0"
                                :class="{ hidden: payment_method != 1 }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <!-- <span :class="{'border border-indigo-500': payment_method === 1}" class="border-transparent pointer-events-none absolute -inset-px rounded-lg" aria-hidden="true"></span> -->
                        </label>

                        <label
                            v-if="payment_methods.includes('3')"
                            @click="payment_method = 3"
                            class="relative overflow-hidden flex cursor-pointer rounded-lg border bg-white p-2 shadow-sm focus:outline-none ring-indigo-500"
                            :class="{
                                'border-2 ring-indigo-600 border-indigo-600':
                                    payment_method === 3,
                            }"
                        >
                            <span class="flex">
                                <span class="flex">
                                    <span
                                        id="delivery-method-0-label"
                                        class="text-md font-medium text-gray-900 inline-flex items-center leading-none"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-6 h-6 fill-green-500"
                                        >
                                            <!--! Font Awesome Pro 6.2.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                                            <path
                                                d="M242.4 292.5C247.8 287.1 257.1 287.1 262.5 292.5L339.5 369.5C353.7 383.7 372.6 391.5 392.6 391.5H407.7L310.6 488.6C280.3 518.1 231.1 518.1 200.8 488.6L103.3 391.2H112.6C132.6 391.2 151.5 383.4 165.7 369.2L242.4 292.5zM262.5 218.9C256.1 224.4 247.9 224.5 242.4 218.9L165.7 142.2C151.5 127.1 132.6 120.2 112.6 120.2H103.3L200.7 22.76C231.1-7.586 280.3-7.586 310.6 22.76L407.8 119.9H392.6C372.6 119.9 353.7 127.7 339.5 141.9L262.5 218.9zM112.6 142.7C126.4 142.7 139.1 148.3 149.7 158.1L226.4 234.8C233.6 241.1 243 245.6 252.5 245.6C261.9 245.6 271.3 241.1 278.5 234.8L355.5 157.8C365.3 148.1 378.8 142.5 392.6 142.5H430.3L488.6 200.8C518.9 231.1 518.9 280.3 488.6 310.6L430.3 368.9H392.6C378.8 368.9 365.3 363.3 355.5 353.5L278.5 276.5C264.6 262.6 240.3 262.6 226.4 276.6L149.7 353.2C139.1 363 126.4 368.6 112.6 368.6H80.78L22.76 310.6C-7.586 280.3-7.586 231.1 22.76 200.8L80.78 142.7H112.6z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >Pagar no
                                            <span class="font-bold"
                                                >PIX</span
                                            ></span
                                        >
                                    </span>
                                    <!-- <span id="delivery-method-0-description-0" class="mt-1 flex items-center text-sm text-gray-500">Aprovação Imediata</span> -->
                                    <!-- <span id="delivery-method-0-description-1" class="mt-2 text-sm font-medium text-gray-900">Pague apenas: R$ 129,90</span> -->
                                </span>
                            </span>
                            <svg
                                class="h-5 w-5 text-indigo-600 absolute top-0 right-0"
                                :class="{ hidden: payment_method != 3 }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <!-- <span :class="[payment_method == 3 ? 'border-2' : 'border-2', payment_method == 3 ? 'border-indigo-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']" class="border-transparent pointer-events-none absolute -inset-px rounded-lg" aria-hidden="true"></span> -->
                        </label>

                        <label
                            v-if="payment_methods.includes('2')"
                            @click="payment_method = 2"
                            class="relative overflow-hidden cursor-pointer rounded-lg border bg-white p-2 shadow-sm focus:outline-none ring-indigo-500"
                            :class="{
                                'border-2 ring-indigo-600 border-indigo-600':
                                    payment_method === 2,
                            }"
                        >
                            <span class="flex flex-1">
                                <span class="flex flex-col">
                                    <span
                                        id="delivery-method-0-label"
                                        class="text-md font-medium text-gray-900 inline-flex items-center leading-none"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 512 512"
                                            class="w-6 h-6"
                                        >
                                            <!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                                            <path
                                                d="M24 32C10.7 32 0 42.7 0 56V456c0 13.3 10.7 24 24 24H40c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H24zm88 0c-8.8 0-16 7.2-16 16V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16zm72 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H184zm96 0c-13.3 0-24 10.7-24 24V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H280zM448 56V456c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24H472c-13.3 0-24 10.7-24 24zm-64-8V464c0 8.8 7.2 16 16 16s16-7.2 16-16V48c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
                                            />
                                        </svg>
                                        <span class="inline-block ml-2"
                                            >Boleto Bancário</span
                                        >
                                    </span>
                                    <!-- <span id="delivery-method-0-description-0" class="mt-1 flex items-center text-sm text-gray-500">Aprovação Imediata</span> -->
                                    <!-- <span id="delivery-method-0-description-1" class="mt-2 text-sm font-medium text-gray-900">Pague apenas: R$ 129,90</span> -->
                                </span>
                            </span>
                            <svg
                                class="h-5 w-5 text-indigo-600 absolute top-0 right-0"
                                :class="{ hidden: payment_method != 2 }"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                                aria-hidden="true"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                    clip-rule="evenodd"
                                />
                            </svg>
                            <!-- <span :class="[payment_method == 2 ? 'border-2' : 'border-2', payment_method == 2 ? 'border-indigo-500' : 'border-transparent', 'pointer-events-none absolute -inset-px rounded-lg']" class="border-transparent pointer-events-none absolute -inset-px rounded-lg" aria-hidden="true"></span> -->
                        </label>
                    </div>
                </div>

                <div class="py-3">
                    <div
                        class="flex flex-wrap"
                        v-if="paymentMethodSelected === 1"
                    >
                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            :value="payment.card_number"
                            var="payment"
                            ref="card_number"
                            :forceValidation="forceValidation.card_number"
                            type="tel"
                            name="card_number"
                            errors="Número do cartão de crédito"
                            label="Cartão de Crédito"
                            :rules="{
                                required: true,
                                minlenght: 8,
                                validateCardNumberNew: true,
                            }"
                            :maxlenght="21"
                            :masksD="[
                                '#### #### #### ####',
                                '#### ###### ######',
                                '#### ###### ####',
                            ]"
                            placeholder="0000 0000 0000 0000"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            :value="lead.name"
                            var="payment"
                            ref="card_holdername"
                            type="text"
                            name="card_holdername"
                            errors="Nome do titular do cartão"
                            label="Nome do titular do cartão"
                            :rules="{ required: true, minlenght: 5 }"
                            placeholder="EX: F DA SILVA"
                            class="hidden"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            :masksD="['##/##', '##/####']"
                            :masked="true"
                            :value="payment.card_expiration"
                            var="payment"
                            ref="card_expiration"
                            type="tel"
                            name="card_expiration"
                            errors="Validade do cartão de crédito"
                            :forceValidation="forceValidation.card_expiration"
                            label="Mês e Ano Validade do Cartão"
                            :rules="{ required: true, expiration_date: true }"
                            placeholder="MM/AA"
                        />

                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            :masksD="['###', '####']"
                            ref="card_cvv"
                            :value="payment.card_cvv"
                            var="payment"
                            type="tel"
                            name="card_cvv"
                            errors="Código de Segurança do Cartão"
                            label="Código CVV"
                            :forceValidation="forceValidation.card_cvv"
                            :rules="{ required: true, minlenght: 3 }"
                            :minlenght="3"
                            placeholder="***"
                        />
                    </div>

                    <div class="flex flex-wrap">
                        <div
                            v-if="paymentMethodSelected === 3"
                            class="p-3 bg-gray-200 border border-gray-300 text-md rounded-md leading-none my-2"
                        >
                            <span
                                class="text-lg text-black font-bold leading-none mb-3 block"
                                >Pix:</span
                            >

                            <!-- <p class="py-2 font-bold">Valor à vista:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    {{ convertCurrency($store.getters['getSumary'].total_amount / 100, 'R$ ', 2) }}.</p> -->
                            <p class="py-2">- Liberação imediata!</p>
                            <p class="py-2">
                                - É simples, só usar o aplicativo de seu banco
                                para pagar PIX.
                            </p>
                            <p class="py-2">
                                - Super seguro. O pagamento PIX foi desenvolvido
                                pelo Banco Central para facilitar pagamentos.
                            </p>
                        </div>

                        <div
                            v-if="paymentMethodSelected === 2"
                            class="p-3 bg-gray-200 border border-gray-300 text-md rounded-md leading-none my-2"
                        >
                            <span
                                class="text-lg text-black font-bold leading-none mb-3 block"
                                >Boleto bancário:</span
                            >
                            <p class="py-2">- Liberação em até 3 dias úteis</p>
                            <p class="py-2">
                                - Pagamento pelo internet banking ou lotéricas.
                            </p>
                        </div>
                        <TwInputText
                            @updateFieldsForm="updateFieldsForm"
                            class_names="w-full md:w-1/2"
                            :masksD="['###.###.###-##']"
                            ref="cpf"
                            :forceValidation="forceValidation.number"
                            type="tel"
                            name="cpf"
                            :value="lead.cpf"
                            var="lead"
                            errors="Informe o CPF"
                            label="CPF"
                            :rules="{ required: true, document: true }"
                            placeholder="000.000.000-00"
                        />
                        <div class="w-full" v-if="paymentMethodSelected === 1">
                            <label
                                for="installments"
                                class="block text-sm font-medium text-gray-700"
                                >Selecione a parcela desejada</label
                            >
                            <select
                                id="installments"
                                name="installments"
                                ref="installments"
                                class="mt-1 block w-full rounded-md border-gray-300 py-2 pl-3 border-2 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                @change="
                                    $store.commit(
                                        'setInstallments',
                                        $event.target.value
                                    )
                                "
                            >
                                <option
                                    v-for="(item, indice) in $store.getters[
                                        'getSumary'
                                    ]['installments_data']"
                                    :key="indice"
                                    :value="indice"
                                    :selected="
                                        $store.getters['getSumary']
                                            .installments == indice
                                    "
                                >
                                    {{ indice }}x
                                    {{
                                        convertCurrency(
                                            item.amount_installment / 100,
                                            'R$ ',
                                            2
                                        )
                                    }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>

                <button
                    @click.prevent.stop="
                        isClickSubmitButton = true
                        checkValid()
                    "
                    ref="submit"
                    id="pay_btn"
                    class="mt-3 border-b-4 border-green-700 w-full block items-center py-3 font-semibold leading-6 text-xl text-center justify-center shadow rounded-md text-white bg-green-600"
                >
                    PAGAR AGORA
                </button>

                <img
                    src="/img/compra-segura.png"
                    alt="Compra Segura"
                    width="296"
                    height="42"
                    class="block mt-2 mx-auto"
                />
            </div>
        </form>
        <!-- Apenas um módulo que faz o processamento do pedido -->
        <Payment
            v-if="checkFirstStepValid"
            :submitting="submitting"
            :payment_method="paymentMethodSelected"
            @callbackSubmit="callbackSubmit"
        />
    </div>
</template>
